import { COMMON, type CommonProps } from '#app/theme/constants.js';
import { sx, type SXProps } from '#app/theme/utils.js';
import { type ComponentPropsWithoutRef } from 'react';
import { css, styled } from 'styled-components';

type SelectMenuHeaderProps = CommonProps & SXProps;

const SelectMenuTitle = styled.h3`
  font-size: inherit;
  margin: 0;
`;

const StyledSelectMenuHeader = styled.header<SelectMenuHeaderProps>`
  ${({ theme }) => css`
    color: ${theme.colorsV2.gray60};
    font-size: 14px;
    padding: 12px 16px 4px;

    &:not(:first-child) {
      border-top: 1px solid ${theme.colorsV2.gray30};
    }
  `}

  ${COMMON}
  ${sx}
`;

const SelectMenuHeader = ({
  children,
  ...props
}: ComponentPropsWithoutRef<'header'> & SelectMenuHeaderProps) => (
  <StyledSelectMenuHeader {...props}>
    <SelectMenuTitle>{children}</SelectMenuTitle>
  </StyledSelectMenuHeader>
);

SelectMenuHeader.displayName = 'SelectMenu.Header';

export { SelectMenuHeader };
